(function () {
  var ATTRIBUTE_NAMES = {
    country: 'Econt Country',
    office_id: 'Econt Office ID',
    office_code: 'Econt Office Code',
    office_type: 'Econt Office Type',
    office_name: 'Econt Office Name',
    office_address: 'Econt Office Address',
    office_city: 'Econt Office City',
    office_postcode: 'Econt Office Postcode',
    office_location: 'Econt Office Location'
  };

  var CONFLICTING_ATTRIBUTE_NAMES = [
    'BOX NOW Locker ID',
    'BOX NOW Locker Name',
    'BOX NOW Locker Address',
    'BOX NOW Locker Postal Code',
    'DPD Country',
    'DPD Pickup ID',
    'DPD Pickup Type',
    'DPD Pickup Name',
    'DPD Pickup Address',
    'DPD Pickup City',
    'DPD Pickup Postcode',
    'Speedy Country',
    'Speedy Pickup ID',
    'Speedy Pickup PUDO ID',
    'Speedy Pickup Type',
    'Speedy Pickup Name',
    'Speedy Pickup Address',
    'Speedy Pickup City',
    'Speedy Pickup Postcode'
  ];

  var EMPTY_VALUES = {
    country: '',
    office_id: '',
    office_code: '',
    office_type: '',
    office_name: '',
    office_address: '',
    office_city: '',
    office_postcode: '',
    office_location: ''
  };

  var DEFAULT_MESSAGES = {
    defaultName: 'Selected Econt office',
    saving: 'Saving Econt office...',
    saved: 'Econt office saved.',
    saveMissing: 'Shopify did not return the Econt office on the cart. Please try again.',
    saveFailed: 'Shopify could not save the Econt office. Please try again.',
    waitSaving: 'Please wait while your Econt office is saved.',
    required: 'Please choose an Econt office before checkout.',
    missingId: 'This Econt office did not return an office code. Choose another office.'
  };

  function getRoot() {
    return document.querySelector('[data-econt-pickup]');
  }

  function getCartRoot() {
    return window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
  }

  function toDatasetMessageKey(key) {
    return 'econtMessage' + key.charAt(0).toUpperCase() + key.slice(1);
  }

  function getMessage(root, key) {
    return (root.dataset && root.dataset[toDatasetMessageKey(key)]) || DEFAULT_MESSAGES[key] || '';
  }

  function setMessage(root, message, type) {
    var status = root.querySelector('[data-econt-status]');
    var error = root.querySelector('[data-econt-error]');

    if (status) {
      status.textContent = type === 'success' || type === 'loading' ? message : '';
      status.hidden = !(type === 'success' || type === 'loading');
    }

    if (error) {
      error.textContent = type === 'error' ? message : '';
      error.hidden = type !== 'error';
    }
  }

  function setFields(root, values) {
    Object.keys(ATTRIBUTE_NAMES).forEach(function (key) {
      var field = root.querySelector('[data-econt-field="' + key + '"]');

      if (field) {
        field.value = values[key] || '';
      }
    });
  }

  function getOfficeIdentifier(root) {
    var code = root.querySelector('[data-econt-field="office_code"]');
    var id = root.querySelector('[data-econt-field="office_id"]');
    return code && code.value ? code.value : id && id.value ? id.value : '';
  }

  function firstValue() {
    for (var index = 0; index < arguments.length; index += 1) {
      var value = arguments[index];

      if (value !== undefined && value !== null && value !== '' && typeof value !== 'object') {
        return value;
      }
    }

    return '';
  }

  function nestedValue(object, path) {
    var value = object;

    path.split('.').forEach(function (part) {
      value = value && typeof value === 'object' ? value[part] : undefined;
    });

    return value;
  }

  function formatLocation(location) {
    var latitude = location && firstValue(location.latitude, location.lat);
    var longitude = location && firstValue(location.longitude, location.lng, location.lon);
    return latitude && longitude ? String(latitude) + ',' + String(longitude) : '';
  }

  function normalizeOffice(payload, country) {
    if (typeof payload === 'string') {
      try {
        payload = JSON.parse(payload);
      } catch (error) {
        // Keep plain strings as office codes.
      }
    }

    var office = payload && payload.office ? payload.office : payload;

    if (typeof office === 'string' || typeof office === 'number') {
      return {
        country: country,
        office_id: '',
        office_code: String(office),
        office_type: '',
        office_name: '',
        office_address: '',
        office_city: '',
        office_postcode: '',
        office_location: ''
      };
    }

    office = office || {};

    var address = office.address && typeof office.address === 'object' ? office.address : {};
    var city = address.city && typeof address.city === 'object' ? address.city : {};
    var location = address.location || office.location || {};

    var values = {
      country: country,
      office_id: String(firstValue(office.id, office.officeId, office.officeID) || ''),
      office_code: String(firstValue(office.code, office.officeCode, office.office_code, office.id) || ''),
      office_type: String(firstValue(office.type, office.officeType, office.kind) || ''),
      office_name: String(firstValue(office.name, office.nameEn, office.officeName, office.title) || ''),
      office_address: String(firstValue(
        address.fullAddress,
        address.fullAddressEn,
        office.fullAddress,
        office.addressText,
        typeof office.address === 'string' ? office.address : ''
      ) || ''),
      office_city: String(firstValue(city.name, city.nameEn, address.cityName, office.city, office.cityName) || ''),
      office_postcode: String(firstValue(city.postCode, address.postCode, office.postCode, office.postalCode) || ''),
      office_location: formatLocation(location)
    };

    return values;
  }

  function renderSelection(root, values) {
    var selectedBox = root.querySelector('[data-econt-selected]');
    var selectedName = root.querySelector('[data-econt-selected-name]');
    var selectedAddress = root.querySelector('[data-econt-selected-address]');

    if (selectedName) {
      selectedName.textContent = values.office_name || (values.office_code ? getMessage(root, 'defaultName') + ' #' + values.office_code : getMessage(root, 'defaultName'));
    }

    if (selectedAddress) {
      selectedAddress.textContent = [
        values.office_city,
        values.office_address,
        values.office_postcode
      ].filter(Boolean).join(', ');
    }

    if (selectedBox) {
      selectedBox.hidden = !values.office_code;
    }
  }

  function buildCartData(values) {
    var formData = new FormData();

    Object.keys(ATTRIBUTE_NAMES).forEach(function (key) {
      formData.append('attributes[' + ATTRIBUTE_NAMES[key] + ']', values[key] || '');
    });

    CONFLICTING_ATTRIBUTE_NAMES.forEach(function (name) {
      formData.append('attributes[' + name + ']', '');
    });

    return formData;
  }

  function saveToCart(values) {
    return fetch(getCartRoot() + 'cart/update.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: buildCartData(values)
    }).then(function (response) {
      return response.json().then(function (cart) {
        if (!response.ok) {
          var error = new Error('Shopify cart update failed');
          error.cart = cart;
          throw error;
        }

        return cart;
      });
    });
  }

  function saveOffice(root, payload) {
    var values = normalizeOffice(payload, root.dataset.econtCountry || 'BG');

    if (!values.office_code) {
      window.EcontPickupLastIgnoredMessage = payload;
      setMessage(root, getMessage(root, 'missingId'), 'error');
      return Promise.resolve(false);
    }

    root.dataset.econtSaving = 'true';
    root.dataset.econtSaved = 'false';
    setFields(root, values);
    renderSelection(root, values);
    setMessage(root, getMessage(root, 'saving'), 'loading');

    return saveToCart(values)
      .then(function (cart) {
        var saved = cart.attributes && cart.attributes[ATTRIBUTE_NAMES.office_code];

        window.EcontPickupLastSave = {
          attributes: values,
          cartAttributes: cart.attributes,
          rawSelection: payload,
          saved: Boolean(saved)
        };

        root.dataset.econtSaving = 'false';
        root.dataset.econtSaved = saved ? 'true' : 'false';
        setMessage(root, saved ? getMessage(root, 'saved') : getMessage(root, 'saveMissing'), saved ? 'success' : 'error');
        return Boolean(saved);
      })
      .catch(function (error) {
        window.EcontPickupLastError = error;
        root.dataset.econtSaving = 'false';
        root.dataset.econtSaved = 'false';
        setFields(root, EMPTY_VALUES);
        renderSelection(root, EMPTY_VALUES);
        setMessage(root, getMessage(root, 'saveFailed'), 'error');
        return false;
      });
  }

  function originList(root) {
    var configured = root.dataset.econtWidgetOrigin || 'https://officelocator.econt.com';

    return configured.split(',').map(function (origin) {
      return origin.trim();
    }).filter(Boolean);
  }

  function isAllowedWidgetOrigin(root, origin) {
    return originList(root).indexOf(origin) !== -1;
  }

  function handleWidgetMessage(event) {
    var root = getRoot();

    if (!root || !isAllowedWidgetOrigin(root, event.origin)) {
      return;
    }

    if (!event.data || event.data.office === undefined) {
      return;
    }

    saveOffice(root, event.data);
  }

  function blockCheckout(event) {
    var root = getRoot();
    var checkout = event.target.closest && event.target.closest('button[name="checkout"], input[name="checkout"]');

    if (!root || !checkout || root.dataset.econtRequired !== 'true') {
      return;
    }

    if (root.dataset.econtSaving === 'true') {
      setMessage(root, getMessage(root, 'waitSaving'), 'error');
      root.scrollIntoView({ behavior: 'smooth', block: 'center' });
      event.preventDefault();
      event.stopPropagation();
      return;
    }

    if (getOfficeIdentifier(root) && root.dataset.econtSaved === 'true') {
      return;
    }

    setMessage(root, getMessage(root, 'required'), 'error');
    root.scrollIntoView({ behavior: 'smooth', block: 'center' });
    event.preventDefault();
    event.stopPropagation();
  }

  function init() {
    var root = getRoot();

    if (!root || root.dataset.econtInitialized === 'true') {
      return;
    }

    root.dataset.econtInitialized = 'true';
    root.dataset.econtSaving = 'false';
    root.dataset.econtSaved = getOfficeIdentifier(root) ? 'true' : 'false';

    window.addEventListener('message', handleWidgetMessage, false);
    document.addEventListener('click', blockCheckout, true);
  }

  window.EcontPickup = {
    save: function (payload) {
      var root = getRoot();
      return root ? saveOffice(root, payload) : Promise.resolve(false);
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
